import { FormEvent, useState } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import '../App.css';

const RMM_ONLINE_PASSWORD = 'gcare123';
const RMM_ONLINE_REDIRECT_URL = 'https://www.rmmonline.co.uk/?implicit-login=true';

function RmOnline() {
  const [passwordInput, setPasswordInput] = useState('');
  const [passwordError, setPasswordError] = useState(false);

  function handleSubmit(e: FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (passwordInput === RMM_ONLINE_PASSWORD) {
      setPasswordError(false);
      window.location.href = RMM_ONLINE_REDIRECT_URL;
      return;
    }
    setPasswordError(true);
    setPasswordInput('');
  }

  return (
    <>
      <Helmet>
        <title>RMM Online | Harpwood House</title>
        <meta name="robots" content="noindex, nofollow" />
        <link rel="canonical" href="https://www.harpwood.house/rmonline" />
      </Helmet>

      <div className="page rmonline-page">
        <a href="#main-content" className="skip-link">
          Skip to main content
        </a>

        <main id="main-content" className="rmonline-main">
          <div className="rmonline-container">
            <section className="rmonline-gate" aria-labelledby="rmonline-heading">
            <Link to="/" className="rmonline-logo" aria-label="Harpwood House Care Suites home">
              <span className="rmonline-logo__title">Harpwood House</span>
              <span className="rmonline-logo__subtitle">Care Suites</span>
            </Link>

              <h1 id="rmonline-heading" className="rmonline-heading">
                RMM Online
              </h1>
              <p className="rmonline-intro">Enter your password to continue</p>

              <form className="phone-calls-form" onSubmit={handleSubmit} noValidate>
                <label htmlFor="rmonline-password" className="phone-calls-label">
                  Password
                </label>
                <input
                  id="rmonline-password"
                  name="password"
                  type="password"
                  autoComplete="current-password"
                  className="phone-calls-input"
                  value={passwordInput}
                  onChange={(ev) => {
                    setPasswordInput(ev.target.value);
                    setPasswordError(false);
                  }}
                />
                {passwordError && (
                  <p className="phone-calls-form-error" role="alert">
                    Incorrect password. Please try again.
                  </p>
                )}
                <button type="submit" className="phone-calls-submit">
                  Enter
                </button>
              </form>
            </section>
          </div>
        </main>
      </div>
    </>
  );
}

export default RmOnline;
